import {API_DRIVER} from "../config/axios";
import {WishStatus, WishType} from "../store/wish/Helper";
import {ICreateEditWish} from "../component/admin-panel/wishes/create-edit-wish-dialog/CreateEditWishDialogHelper";
import {
    IEditActiveWish
} from "../component/admin-panel/wishes/wishes-table/edit-active-wish-dialog/EditActiveWishDialogHelper";

const getWishRequestUrl = (endpointUrl?: string) => {
    return `/api/wishes${endpointUrl ?? ''}`
}

const WishService = {
    fetchWishes: (params: {
        wish_status?: WishStatus
        limit: number
        offset: number
        sort_by: string
        sort_order: string
        search_text?: string
        category_id?: string
        recommended_first?: boolean
        client_id?: string
        type?: WishType,
        city?: string,
        for_admin_panel?: boolean,
        exclude_free?: boolean,
        included_draw_wish_id?: string
    }) => {
        return API_DRIVER.get(getWishRequestUrl(), {
            params: {...params}
        })
    },
    fetchWishDetails: (id: string) => {
        return API_DRIVER.get(getWishRequestUrl(`/${id}`))
    },
    fetchWishImages: (id: string) => {
        return API_DRIVER.get(getWishRequestUrl(`/${id}/images`))
    },
    createWish: (body: ICreateEditWish) => {
        return API_DRIVER.post(getWishRequestUrl(), body)
    },
    deleteWish: (id: string) => {
        return API_DRIVER.delete(getWishRequestUrl(`/${id}`))
    },
    publishWish: (id: string) => {
        return API_DRIVER.put(getWishRequestUrl(`/${id}/publish`))
    },
    terminateWish: (id: string) => {
        return API_DRIVER.put(getWishRequestUrl(`/${id}/terminate`))
    },
    redrawWinners: (id: string) => {
        return API_DRIVER.get(getWishRequestUrl(`/${id}/redraw-winners`))
    },
    rescheduleWish: (id: string) => {
        return API_DRIVER.get(getWishRequestUrl(`/${id}/reschedule-wish-draw`))
    },
    editWish: (id: string, body: ICreateEditWish | IEditActiveWish) => {
        return API_DRIVER.put(getWishRequestUrl(`/${id}`), body)
    },
    uploadImages: (wishId: string, formData: FormData) => {
        return API_DRIVER.put(getWishRequestUrl(`/${wishId}/images`), formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        })
    },
    fetchMyWishes: (params: {
        wish_status: WishStatus,
        sort_by?: string,
        sort_order?: string,
        search_text?: string,
        category_id?: string
        type?: WishType
    }) => {
        return API_DRIVER.get(getWishRequestUrl('/my-wishes'), {
            params: {...params}
        })
    },
    duplicateWish: (id: string) => {
        return API_DRIVER.post(getWishRequestUrl(`/${id}/duplicate`))
    },
    fetchHiddenWishFields: (id: string) => {
        return API_DRIVER.get(getWishRequestUrl(`/${id}/hidden`))
    },
    fetchCitiesWithCounts: (type?: WishType) => {
        return API_DRIVER.get(getWishRequestUrl(`/get/cities-with-count`), {
            params: {
                wish_type: type,
            }
        })
    },
}

export default WishService
